// import 'svgxuse'; // Uncomment to support svg icons on IE
import $ from 'jquery';
import 'jquery-modal';
import hamburgerIcon from 'fjaka/js/components/hamburger-icon';
import './components/header';
import './components/offcanvas';
import './components/progress';
import './components/modal';
import './components/lookup';
import './components/blocklist';

hamburgerIcon( $ );
